//To handle more microservice

export const getbaseUrl = (url) => {
  switch (url) {
    case "auth":
      return process.env.REACT_APP_API_URL;
    case "orders":
      return process.env.REACT_APP_API_ORDER_URL;
    case "products":
      return process.env.REACT_APP_API_PRODUCTS_URL;
    case "cms":
      return process.env.REACT_APP_API_CMS_URL;
    case "communication":
      return process.env.REACT_APP_API_COMMUNICATION_URL;
    case "appointment":
      return process.env.REACT_APP_API_APPOINTMENT_URL;
    default:
      return process.env.REACT_APP_API_URL;
  }
};
